/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `mm/duration` - mm/duration
 * * `mm/h` - mm/h
 * * `m/s` - m/s
 * @export
 */
export const LizardUnitsEnum = {
  MM_DURATION: "mm/duration",
  MM_H: "mm/h",
  M_S: "m/s",
} as const;
export type LizardUnitsEnum = (typeof LizardUnitsEnum)[keyof typeof LizardUnitsEnum];

export function instanceOfLizardUnitsEnum(value: any): boolean {
  for (const key in LizardUnitsEnum) {
    if (Object.prototype.hasOwnProperty.call(LizardUnitsEnum, key)) {
      if (LizardUnitsEnum[key as keyof typeof LizardUnitsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LizardUnitsEnumFromJSON(json: any): LizardUnitsEnum {
  return LizardUnitsEnumFromJSONTyped(json, false);
}

export function LizardUnitsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LizardUnitsEnum {
  return json as LizardUnitsEnum;
}

export function LizardUnitsEnumToJSON(value?: LizardUnitsEnum | null): any {
  return value as any;
}

export function LizardUnitsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): LizardUnitsEnum {
  return value as LizardUnitsEnum;
}
